import React, { useRef, useState } from 'react';
import icUpload from 'Assets/img/recruitment/ic_upload.png';
import icUpload2 from 'Assets/img/recruitment/ic_upload@2x.png';
import icUpload3 from 'Assets/img/recruitment/ic_upload@3x.png';
import icDelete from 'Assets/img/recruitment/ic_delete.png';
import icDelete2 from 'Assets/img/recruitment/ic_delete@2x.png';
import icDelete3 from 'Assets/img/recruitment/ic_delete@3x.png';
import { getFileName, getImageSet } from 'Util/DataUtils';
import { uploadFileApplyMyFiles } from 'Api/endpoints/Recruitment';
import InputTitleView from './InputTitleView';
import IntlMessages from 'Util/IntlMessages';
import { saveAs } from 'file-saver';
import { CircularProgress } from '@mui/material';
import { useError } from 'Api/hooks/useError';

const uploads = getImageSet([icUpload, icUpload2, icUpload3]);
const deleteButtons = getImageSet([icDelete, icDelete2, icDelete3]);
const MultiFileInputView = ({ title = '', required = false, subTitle = '', placeholder = '', name, value, onChange, errText = '', subText = '' }) => {
  const inputRef = useRef();
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [isTextEmpty, setIsTextEmpty] = useState(false);
  const { showErrorPopup } = useError();

  const uploadImage = async image => {
    try {
      const result = await uploadFileApplyMyFiles(image);
      if (result.err) {
        showErrorPopup({ text: result.err.response.data.message });
        return null;
      }
      return result.data.image.origin_path;
    } catch (e) {
      console.log(e);
    }
  };

  const onChangeImage = async e => {
    const image = e.target.files[0];
    if (!image) return null;
    setLoading(true);
    const result = await uploadImage(image);
    if (result) {
      onChange({ name, value: [...value, { name: text, file: result }] });
      setText('');
    }
    setLoading(false);
  };

  return (
    <div className="recruitment-multi-file-input-view">
      <InputTitleView title={title} required={required} subTitle={subTitle} />
      <div className="multi-file-wrapper">
        <div className="recruitment-multi-file-input-wrapper">
          <div className={`recruitment-multi-file-input-text ${isTextEmpty && 'text-error'}`}>
            <input
              type="text"
              placeholder={placeholder}
              value={text}
              onChange={({ target: { value } }) => {
                setText(value);
                setIsTextEmpty(false);
              }}
            />
          </div>
          <div className="recruitment-multi-file-input-file">
            {loading ? (
              <div className="recruitment-multi-file-input-view-input">
                <CircularProgress size={24} />
              </div>
            ) : (
              <>
                <input type="file" ref={inputRef} onChange={onChangeImage} accept="image/*, .pdf" style={{ display: 'none' }} />
                <div
                  className="recruitment-multi-file-input-view-input"
                  onClick={() => {
                    if (!text) {
                      setIsTextEmpty(true);
                      return null;
                    }
                    if (!loading) {
                      inputRef.current.click();
                    }
                  }}
                >
                  <img {...uploads} alt="upload" />
                  <div className="recruitment-multi-file-input-view-input-text">
                    <IntlMessages id="common.fileUpload.text" />
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        {isTextEmpty && <div className="recruitment-multi-file-input-error">{errText}</div>}
        <div className="recruitment-multi-file-input-subText">{subText}</div>
        {value.length > 0 && (
          <div className="recruitment-multi-file-result-wrapper">
            {value.map((x, i) => (
              <div key={`result_${i}`} className="recruitment-multi-file-result">
                <div className="recruitment-multi-file-result-name" onClick={() => saveAs(x.file, getFileName(x.file))}>
                  {x.name}
                </div>
                <div className="recruitment-multi-file-result-img">
                  <img
                    {...deleteButtons}
                    alt="delete"
                    onClick={() => {
                      onChange({ name, value: value.filter((_, index) => index !== i) });
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MultiFileInputView;
